import React, { Suspense, useEffect, useState } from 'react'
import App from './App'
import { useSelector } from 'react-redux';
import PrivateRoute from './components/PrivateRoute.js';
import { Route, Routes } from 'react-router-dom';
import CustomToast from './components/globalComponents/CustomToast.js';
import { components } from 'react-select';
import CustomSpinner from './components/globalComponents/CustomSpinner.js';
import RouteComponents from './routes/routeComponents.js';

const routeObj = {
  dashboard: {
    path: "/",
    name: "Dashboard",
    component: RouteComponents.Dashboard
  },
  my_profile: {
    path: "/my-profile",
    name: "Profile",
    component: RouteComponents.Profile
  },
  onboarding: {
    path: "/onboarding",
    name: "Onboarding",
    component: RouteComponents.Onboarding
  },
  community: {
    path: "/community",
    name: "Community",
    component: RouteComponents.Community
  },
  kudos: {
    path: "/kudos",
    name: "Kudos",
    component: RouteComponents.Kudos
  },
  attendance_dashboard: {
    path: "/attendance-dashboard",
    name: "Attendance Dashboard",
    component: RouteComponents.AttendanceDashboard
  },
  leave_management: {
    path: "/leave-management/:activeTabName?",
    name: "Leave Management",
    component: RouteComponents.LeaveManagement
  },
  team_attendance: {
    path: "/team-attendance",
    name: "Team Attendances",
    component: "TeamAttendances"
  },
  team_attendance_attendance_calender_id: {
    path: "/team-attendance/attendance-calender/:id",
    name: "Emp Attendance Calender",
    component: RouteComponents.EmpAttendanceCalender
  },
  holiday_list: {
    path: "/holiday-list",
    name: "Holiday List",
    component: RouteComponents.HolidayList
  },
  permissions: {
    path: "/permissions",
    name: "Permissions",
    component: RouteComponents.Permissions
  },
  other_attendance: {
    path: "/other-attendance",
    name: "Other Attendance",
    component: RouteComponents.OtherAttendance
  },
  shift_management: {
    path: "/shift-management",
    name: "Shift Management",
    component: RouteComponents.ShiftManagement
  },
  shift_setting: {
    path: "/shift-setting",
    name: "Shift Setting",
    component: RouteComponents.ShiftSetting
  },
  shift_management_userId_startDate_endDate: {
    path: "/shift-management/:userId/:startDate/:endDate",
    name: "User Shift Details",
    component: RouteComponents.UserShiftDetails
  },

  ticket_management_system: {
    path: "/ticket-management-system",
    name: "Ticket Management System",
    component: RouteComponents.TicketManagementSystem
  },
  employee: {
    path: "/employee",
    name: "Employee",
    component: RouteComponents.Employee
  },

  add_employee_salary: {
    path: "/employee/add-employee-salary",
    name: "Add Update Emp Salary",
    component: RouteComponents.AddUpdateEmpSalary
  },

  leave: {
    path: "/Leave",
    name: "Leave",
    component: RouteComponents.Leave
  },
  // position: {
  //   path: "/position",
  //   name: "Position",
  //   component: Position
  // },
  qualification: {
    path: "/qualification",
    name: "Qualification",
    component: RouteComponents.Qualification
  },
  training_certificates: {
    path: "/training-certificates",
    name: "Training Certificate",
    component: RouteComponents.TrainingCertificate
  },
  // locations: {
  //   path: "/locations",
  //   name: "Location",
  //   component: Location
  // },
  holiday: {
    path: "/holiday",
    name: "Holiday",
    component: RouteComponents.Holiday
  },
  approval_management: {
    path: "/approval-management",
    name: "Approval Management",
    component: RouteComponents.ApprovalManagement
  },
  policies: {
    path: "/policies",
    name: "Policies",
    component: RouteComponents.Policies
  },
  dropdown_master: {
    path: "/dropdown-master",
    name: "Drop Down Master",
    component: RouteComponents.DropDownMaster
  },
  mrf: {
    path: "/mrf",
    name: "Mrf",
    component: RouteComponents.Mrf
  },
  interview_panel: {
    path: "/interview-panel",
    name: "Interview Panel",
    component: RouteComponents.InterviewPanel
  },
  employee_refereal: {
    path: "/employee-refereal",
    name: "Employee Refereal",
    component: RouteComponents.EmployeeRefereal
  },
  mrf_process_step_mrfType_id: {
    path: "/mrf-process-step/:mrfType/:id?",
    name: "Mrf Process Steps",
    component: RouteComponents.MrfProcessSteps
  },
  hr_dashboard: {
    path: "/hr-dashboard",
    name: "Hr Dashboard",
    component: RouteComponents.HrDashboard
  },
  email_template: {
    path: "/email-template",
    name: "Email Template",
    component: RouteComponents.EmailTemplate
  },
  feedback: {
    path: "/feedback",
    name: "Feedback",
    component: RouteComponents.Feedback
  },
  pay_runs: {
    path: "/pay-runs",
    name: "Pay Runs",
    component: RouteComponents.PayRuns
  },
  regular_payroll: {
    path: "/regular-payroll/:payMonth",
    name: "Regular Pay Roll",
    component: RouteComponents.RegularPayRoll
  },
  employee_attendance_tracking: {
    path: "/pay-runs/employee-attendance-tracking/:id/:monthYear",
    name: "Employee Attendance Tracking",
    component: RouteComponents.EmployeeAttendanceTracking
  },
  employee_history: {
    path: "/employee/employee-history",
    name: "Employee History",
    component: RouteComponents.EmployeeHistory
  },
  pms_admin: {
    path: "/pms-admin",
    name: "PMS Admin",
    component: RouteComponents.PMSAdmin
  },
  create_kra: {
    path: "/create-kra",
    name: "Create KRA",
    component: RouteComponents.CreateKRA
  },
  my_team: {
    path: "/my-team",
    name: "My Team",
    component: RouteComponents.MyTeam
  },
  my_kra: {
    path: "/my-kra",
    name: "My KRA",
    component: RouteComponents.MyKRA
  },
  team_ranking: {
    path: "/team-ranking",
    name: "Team Ranking",
    component: RouteComponents.TeamRanking
  },
  team_hierarchy: {
    path: "/team-hierarchy",
    name: "Team Hierarchy",
    component: RouteComponents.TeamHierarchy
  },
  kpi_guidelines: {
    path: "/kpi-guidelines",
    name: "KPI Guidelines",
    component: RouteComponents.KPIGuidelines
  },
  employee_probation: {
    path: "/employee-probation",
    name: "Employee Probation",
    component: RouteComponents.EmployeeProbation
  },
  probation_reviews: {
    path: "/probation-reviews",
    name: "Probation Review",
    component: RouteComponents.ProbationReview
  },
  rating_review: {
    path: "/rating-review",
    name: "Rating And Review",
    component: RouteComponents.RatingAndReview
  },
  viewRating: {
    path: "/:ratingName",
    name: "View Rating",
    component: RouteComponents.ViewRating
  },
  notes: {
    path: "/notes",
    name: "Notes",
    component: RouteComponents.Notes
  },
  announcement: {
    path: "/announcement",
    name: "Announcement",
    component: RouteComponents.Announcement
  },
  kudos_approval: {
    path: "/kudos-approval",
    name: "Redeem Point Statement",
    component: RouteComponents.RedeemPointStatement
  },
  payroll_setting: {
    path: "/payroll-setting",
    name: "Payroll Setting",
    component: RouteComponents.PayrollSetting
  },
  credit_debit_leave: {
    path: "/credit-debit-leave",
    name: "Credit Debit Leave",
    component: RouteComponents.CreditDebitLeave
  },
  salary_template: {
    path: "/salary-template",
    name: "Salary Templates",
    component: RouteComponents.SalaryTemplates
  },
  create_salary_template: {
    path: "/salary-template/create-salary-template",
    name: "Create Salary Template",
    component: RouteComponents.CreateUpdateSalaryTemplate
  },
  update_salary_template: {
    path: "/salary-template/update-salary-template/:id",
    name: "Update Salary Template",
    component: RouteComponents.CreateUpdateSalaryTemplate
  },
  earning_deduction_types: {
    path: "/earning-deduction-types",
    name: "Earning Deduction Types",
    component: RouteComponents.EarningDeductionTypes
  },
  payroll_employees: {
    path: "/payroll-employees",
    name: "Payroll Employees",
    component: RouteComponents.PayrollEmployees
  },
  payroll_employees_investment: {
    path: "/payroll-employees/employee-detail",
    name: "Investments",
    component: RouteComponents.Investments
  },
  it_declaration: {
    path: "/payroll-employees/employee-detail/it-declaration",
    name: "IT Declaration",
    component: RouteComponents.ITDeclaration
  },
  proof_of_investment: {
    path: "/payroll-employees/employee-detail/proof-of-Investment",
    name: "Proof Of Investment",
    component: RouteComponents.ProofOfInvestment
  },
  assign_employee_salary: {
    path: "/payroll-employees/add-employee-salary",
    name: "Add Update Emp Salary",
    component: RouteComponents.AddUpdateEmpSalary
  },
  create_pay_run: {
    path: "/pay-runs/create-pay-run/:payMonth",
    name: "Create Pay Run",
    component: RouteComponents.CreatePayRun
  },
  setting: {
    path: "/setting",
    name: "Setting",
    component: RouteComponents.Setting
  },
  manage_location: {
    path: "/manage-location",
    name: "Manage Location",
    component: RouteComponents.ManageLocation
  },
  attendance_lock: {
    path: "/attendance-lock",
    name: "Attendance Lock",
    component: RouteComponents.AttendanceLock
  },
  advance: {
    path: "/advance",
    name: "Advance",
    component: RouteComponents.Advance
  },
  travel: {
    path: "/travel",
    name: "Trip",
    component: RouteComponents.Trip
  },
  travel_setting: {
    path: "/travel-setting",
    name: "Travel Setting",
    component: RouteComponents.TravelSetting
  },
  add_update_travel: {
    path: "/add-update-travel",
    name: "Add Update Trip",
    component: RouteComponents.AddUpdateTrip
  },
  travel_approval_request: {
    path: "/travel-approval-request",
    name: "Travel Approval Request",
    component: RouteComponents.TravelApprovalRequest
  },
  travel_claim: {
    path: "/travel-claim",
    name: "Travel Claim",
    component: RouteComponents.TravelClaim
  },
  financial_year: {
    path: "/financial-year",
    name: "Financial Year",
    component: RouteComponents.FinancialYear
  },
  assign_travel_rules: {
    path: "/travel-setting/assign-travel-rules",
    name: "Assign Rule Designations",
    component: RouteComponents.AssignRuleDesignations
  },
  add_update_travel_claims: {
    path: "/travel-claim/add-update-travel-claims",
    name: "Add Update Travel Claims",
    component: RouteComponents.AddUpdateTravelClaims
  },
  mapping: {
    path: "/mapping",
    name: "Mapping",
    component: RouteComponents.Mapping
  },
  create_kra_assign_kra: {
    path: "/create-kra/assign-kra",
    name: "Assign KRA Employees",
    component: RouteComponents.AssignKRAEmployees
  },
  my_team_employee_rating: {
    path: "/my-team/employee-rating",
    name: "Give Employee Rating",
    component: RouteComponents.GiveEmployeeRating
  },
  self_rating: {
    path: "self-rating",
    name: "self Rating",
    component: RouteComponents.SelfRating
  },
  // role: {
  //   path: "/role",
  //   name: "Role",
  //   component: RouteComponents.Role
  // },
  bulk_upload: {
    path: "/bulk-upload",
    name: "Role",
    component: RouteComponents.BulkUpload
  },
  overall_rating: {
    path: "/overall-rating",
    name: "overall-rating",
    component: RouteComponents.OverallRating
  },
  kudos_and_appreciation: {
    path: "/kudos-and-appreciation",
    name: "kudos And Appreciation",
    component: RouteComponents.KudosAndAppreciation
  },
  rating_feedback: {
    path: "/rating-feedback",
    name: "rating-feedback",
    component: RouteComponents.RattingFeedback
  },
  escalation: {
    path: "/escalation",
    name: "escalation",
    component: RouteComponents.Escalation
  },
  task: {
    path: "/task/status?",
    name: "task",
    component: RouteComponents.Task
  },
  task_status: {
    path: "/task/:status",
    name: "task",
    component: RouteComponents.Task
  },
  task_management_dashboard: {
    path: "/task-management-dashboard",
    name: "dashboard",
    component: RouteComponents.TMDashboard
  },
  task_project: {
    path: "/task-project",
    name: "dashboard",
    component: RouteComponents.TaskProject
  },
  view_task_detail: {
    path: "/view-task-detail",
    name: "Task Detail",
    component: RouteComponents.ViewTaskDetail
  },
  sub_task: {
    path: "/task/sub-task",
    name: "Sub Task",
    component: RouteComponents.SubTask
  },
  admin_dashboard: {
    path: "admin-dashboard",
    name: "admin-dashboard",
    component: RouteComponents.AdminDashboard
  },
  candidates: {
    path: "/candidates",
    name: "Candidates",
    component: RouteComponents.Candidates
  },
  candidate_detail: {
    path: "/candidate/candidate-detail",
    name: "Candidate-detail",
    component: RouteComponents.CandidateDetail
  },
  separation: {
    path: "separation",
    name: "separation",
    component: RouteComponents.Separation
  },
  task_box: {
    path: 'task-box',
    name: "Task Box",
    component: RouteComponents.TaskBox
  },
  masters: {
    path: '/masters',
    name: "Task Box",
    component: RouteComponents.Mapping
  },
  correction_setting: {
    path: '/correction-setting',
    name: "Correction Setting",
    component: RouteComponents.Setting
  },
  leave_setting: {
    path: '/leave-setting',
    name: "Leave Setting",
    component: RouteComponents.Leave
  },
  assets_management: {
    path: '/assets-management',
    name: "Assets Management",
    component: RouteComponents.AssetsManagement
  },
  my_assets: {
    path: '/my-assets',
    name: "My Assets",
    component: RouteComponents.MyAssets
  },
  employee_mood_rating: {
    path: '/employee-mood-rating',
    name: "Employee Mood Rating",
    component: RouteComponents.MoodRating
  },
  attendance_reports: {
    path: '/attendance-report',
    name: "Attendance Reports",
    component: RouteComponents.AttendanceReport
  },
  report: {
    path: '/leave-report',
    name: "Leave Report",
    component: RouteComponents.LeaveReports
  },

  candidate_reports: {
    path: '/candidate-reports',
    name: "Candidate Report",
    component: RouteComponents.CandidateReports
  },
  payroll_reports: {
    path: '/payroll-reports',
    name: "Payroll Reports",
    component: RouteComponents.PayrollReports
  },
  pms_reports: {
    path: '/pms-reports',
    name: "PMS Reports",
    component: RouteComponents.PmsReports
  },
  asset_dashboard: {
    path: '/asset-dashboard',
    name: "Employee Mood Rating",
    component: RouteComponents.AssetsDashboard
  },
  help_desk: {
    path: '/help-desk',
    name: "help-desk",
    component: RouteComponents.HelpDesk
  },
  help_desk_detail: {
    path: '/help-desk-detail',
    name: "Help Desk Detail",
    component: RouteComponents.HelpDeskDetail
  },
  employee_setting: {
    path: '/employee-setting',
    name: "Employee Setting",
    component: RouteComponents.EmployeeSetting
  },
  notification_setting: {
    path: '/notification-setting',
    name: "Notification setting",
    component: RouteComponents.Notification
  },
  ticket_management: {
    path: '/ticket-management',
    name: "Ticket Management",
    component: RouteComponents.TicketManagement

  },
  ticket_management_setting: {
    path: '/ticket-management-setting',
    name: "Ticket Management Setting",
    component: RouteComponents.TicketSetting

  },
  webcast: {
    path: '/webcast',
    name: "Web Cast",
    component: RouteComponents.Webcast

  },
  update_employee_monthly_salary: {
    path: '/regular-payroll/:year_mon/update-employee-monthly-salary',
    name: "update employee monthly salary",
    component: RouteComponents.UpdateEmpMonthlySalary

  },
  view_employee_monthly_salary: {
    path: '/regular-payroll/:year_mon/view-employee-monthly-salary',
    name: "view employee monthly salary",
    component: RouteComponents.ViewEmpMonthlySalary
  },
  client_onboarding: {
    path: '/client-onboarding',
    name: "Client Onboarding",
    component: RouteComponents.ClientOnboarding
  }
,
   organization_details: {
    path: '/organization-details',
    name: "Organization Details",
    component: RouteComponents.OrganizationDetails
  },
    organization_policy: {
    path: '/organization-policy',
    name: "Organization Policy",
    component: RouteComponents.OrganizationPolicy
  },
      organization_setup: {
    path: '/organization-setup',
    name: "organization_setup",
    component: RouteComponents.OrganizationSetup
  },
  payroll: {
    path: '/payroll',
    name: "Payroll",
    component: RouteComponents.EmployeePayroll
  },
  //   candidate_detail: {
  //   path: "/candidate/candidate-detail/:mode",
  //   name: "Candidate-detail",
  //   component: RouteComponents.CandidateDetail
  // },

}


const RenderedRoutes = () => {
  const { getMenuRoutesPermissionRes } = useSelector((state) => state.permission);
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const permissionData = getMenuRoutesPermissionRes?.data;
    if (Array.isArray(permissionData) && permissionData?.length) {
      sessionStorage.setItem("routePermissions", JSON.stringify(permissionData));
      const tempRoutes = [];

      permissionData.forEach((item) => {
        if (routeObj[item.route_key]) {
          tempRoutes.push(routeObj[item.route_key]);
        }

        if (Array.isArray(item.submenu)) {
          item.submenu.forEach((subItem) => {
            if (routeObj[subItem.route_key]) {
              tempRoutes.push(routeObj[subItem.route_key]);
            }
          });
        }
      });

      // Remove duplicates based on path
      const uniqueRoutes = Array.from(
        new Map(tempRoutes.map((route) => [route.path, route])).values()
      );

      setFilteredRoutes(uniqueRoutes);
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [getMenuRoutesPermissionRes]);

  if (!isLoaded && sessionStorage.getItem("authData")) {
    // return <CustomSpinner isShow size="lg" />;
  }

  return (
    <Suspense >
      <Routes>
        <Route path="/" element={<App />}>

          {/* Protected Routes */}
          <Route path="/" element={<PrivateRoute Component={RouteComponents.Dashboard} />}>
            <Route index element={<PrivateRoute Component={RouteComponents.MainDashboard} />} />
            {filteredRoutes.map(({ path, component: Component }, index) => (
              <Route
                key={index}
                path={path}
                element={<PrivateRoute Component={Component} />}
              />
            ))}
          </Route>
        </Route>

        {/* Public Routes */}
        <Route path="/login" element={<RouteComponents.Login />} />

        {/* 404 fallback if permissions are loaded */}
        {isLoaded && (
          <Route path="*" element={<PrivateRoute Component={RouteComponents.PageNotFound} />} />
        )}
      </Routes>

      <CustomToast />
    </Suspense>
  );
};


export default RenderedRoutes;
